import dayjs from "dayjs";

export const docMaskingFields = [
  "PassportNumber",
  "EmiratesIDNumber",
  "VisaNumber",
  "TradeLicenseNumber",
  "TRNNumber",
  "PassportExpiryDate",
  "VisaExpiryDate",
  "TradeLicenseExpiryDate",
  "EmiratesIDExpiryDate",
];

const buildIfValid = (acc, key, value) => {
  if (key) acc[key] = value;
};
const formatDate = (date?: string) => (date ? dayjs(date).format("YYYY-MM-DD") : "");
export const validateFields = (values, changedData, editType) => {
  const emailPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  const numberReg = /^[0-9]+$/;
  const numberCharacterReg = /^[A-Za-z0-9]*$/;

  if (editType === "Tenant Details" && !emailPattern.test(values.Email)) {
    return { field: "EmiratesIDNumber", message: "Please enter valid emirates number" };
  }

  if (editType === "Documents" && !numberCharacterReg.test(changedData.PassportNumber)) {
    return { field: "PassportNumber", message: "Please enter valid passport number" };
  }

  if (editType === "Documents" && !numberCharacterReg.test(changedData.VisaNumber)) {
    return { field: "VisaNumber", message: "Please enter valid visa number" };
  }

  if (
    editType === "Documents" &&
    (changedData?.EmiratesIDNumber || changedData?.EmiratesIDNumber === "") &&
    !numberReg.test(changedData.EmiratesIDNumber)
  ) {
    return { field: "EmiratesIDNumber", message: "Please enter valid emirates number" };
  }

  if (values.numberOfOcupants && !/^\d+$/.test(values.numberOfOcupants)) {
    return { field: "numberOfOcupants", message: "Please enter valid number of occupants" };
  }
};

export const buildDocumentsPayload = (changedData) => {
  if (Object.keys(changedData).length === 0) return {};

  const payload: any = {};

  if ("PassportNumber" in changedData) {
    buildIfValid(payload, "passport", changedData.PassportNumber);
  }

  if ("PassportExpiryDate" in changedData) {
    payload.passportExpiry = formatDate(changedData.PassportExpiryDate);
  }

  if ("EmiratesIDNumber" in changedData) {
    buildIfValid(payload, "emiratesId", changedData.EmiratesIDNumber);
  }

  if ("EmiratesIDExpiryDate" in changedData) {
    payload.emirateIdExpiry = formatDate(changedData.EmiratesIDExpiryDate);
  }

  if ("VisaNumber" in changedData) {
    buildIfValid(payload, "visaNumber", changedData.VisaNumber);
  }

  if ("VisaExpiryDate" in changedData) {
    payload.visaExpiry = formatDate(changedData.VisaExpiryDate);
  }

  if ("TradeLicenseNumber" in changedData) {
    buildIfValid(payload, "tradeLicense", changedData.TradeLicenseNumber);
  }

  if ("TradeLicenseExpiryDate" in changedData) {
    payload.tradeLicenseExpiry = formatDate(changedData.TradeLicenseExpiryDate);
  }

  if ("TRNNumber" in changedData) {
    buildIfValid(payload, "trnNumber", changedData.TRNNumber);
  }

  return payload;
};

export const buildTenantPayload = (values) => ({
  name: values?.FullName,
  arabicName: values?.arabicName,
  email: values?.Email,
  countryCode: "+971",
  maritalStatus: values?.maritalStatus,
  numberOfOcupants: values?.numberOfOcupants,
  poBox: values?.poBox,
  tenantNameAR: values?.tenantNameAR,
  mobile: values?.PhoneNumber,
  nationality: values?.Nationality?.value,
  emirates: values?.Emirates?.value,
  country: values?.Country?.value,
  address: values?.Address,
  isBlocked: values?.isBlocked ? "yes" : "no",
});
